import api from '@/services/api';

const ContractPartyMasterCreate = {
  createContractPartyMaster: (contractPartyMasterId, contractPartyName) => {
    return api.post('create_contract_party_master/', {
      contract_party_master_id: contractPartyMasterId,
      contract_party_name: contractPartyName
    });
  },
  createNotExistContractPartyMaster: (contractPartyList) => {
    return api.post('create_not_exist_contract_party_master/', {
      contract_party_list: contractPartyList
    });
  }
};

export default ContractPartyMasterCreate;



// WEBPACK FOOTER //
// ./src/api/user_contract/contract_party_master/create.js